module.exports = __webpack_public_path__ + "static/media/BBB.ee0148f9.png";